<template>
    <div class="container">
        <PatientsListingFilters 
            :filters="params" 
            :intense-unread-messages-count="intenseUnreadMessagesCount" 
            :order-options="orderOptions"
            @change="onFilters" 
        />

        <div class="matrix-panel">
            <div class="table-layout table-patient">
                <TableHeader v-if="patients.length !== 0" :showDaysTillEndOfSubscription="showDaysTillEndOfSubscription" :freemium="freemium" />

                <PatientsListingTableBody
                    ref="TableBody"
                    :phase="phase"
                    :freemium="freemium"
                    :params="params"
                    :freeze="freeze"
                    :deactivated="deactivated"
                    @fetched="onFetched"
                >
                    <PatientRow v-for="patient in patients" :key="patient.id" :class="{'patient-inactive': freeze || deactivated}" :patient="patient" :showDaysTillEndOfSubscription="showDaysTillEndOfSubscription" />
                </PatientsListingTableBody>
            </div>
        </div>
    </div>
</template>

<script>
import PatientRow from '@components/Coaches/PatientsMatrix/Intensive/PatientRow'
import TableHeader from '@components/Coaches/PatientsMatrix/Intensive/TableHeader'

import PatientsListing from '@components/PatientsMatrix/PatientsMatrix'

export default {
    components: {
        PatientRow,
        TableHeader
    },
    extends: PatientsListing,
    props: {
        intenseUnreadMessagesCount: {
            type: Number,
            required: false
        },
        orderOptions: {
            type: Array,
            required: false,
            default() {
                return []
            }
        },
    },
    mounted() {
        $(function() {
            $('.item-patient').addClass('active')
        })
    }
}
</script>
